module.exports = __webpack_public_path__ + "static/IMG_2406-35f6508e6b733af023764afc187a3ecf.jpg";